import { render } from "./ChangeToApprovalModal.vue?vue&type=template&id=1ecffe66&scoped=true"
import script from "./ChangeToApprovalModal.vue?vue&type=script&lang=js"
export * from "./ChangeToApprovalModal.vue?vue&type=script&lang=js"

import "./ChangeToApprovalModal.vue?vue&type=style&index=0&id=1ecffe66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecffe66"]])

export default __exports__